export const initialLoginFormState = {
  message: "Please log in to continue."
};

export const initialFieldConfigFormState = {};

export default {
  main: {
    isLoggedIn: false,
    token: null,
    accessLevel: 0,
    username: null,
    userId: 0,
    sidebarNavActive: false,
    errors: [],
    notification: {
      show: false,
      type: "info",
      message: ""
    },
    formTemplate: {},
    makingRequest: false,
    timerStart: 0,
    timerClient: null,
    userViewAs: "cards",
    userInstance: "Standard",
    versionMismatch: false,
    screenWidth: Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    )
  },
  time: {
    timeRecorded: 0,
    timeRecordedFormatted: "00:00:00",
    timerRunning: false,
    timerVisible: false,
    timerClient: null,
    timerDefaultClient: null,
    pickingClient: false,
    timerBlur: false,
    usingPreviousTimesheet: false
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js